const supportedEvents = {
  MANUAL_PHOTO: "MANUAL_PHOTO",
  MANUAL_VIDEO: "MANUAL_VIDEO",
  AWAKE_PHOTO: "AWAKE_PHOTO",
  AWAKE_VIDEO: "AWAKE_VIDEO",
  MOTION_PHOTO: "MOTION_PHOTO",
  MOTION_VIDEO: "MOTION_VIDEO",
  AWAKE: "AWAKE",
  SLEEPING: "SLEEPING"
};

const eventsFilters = {
  MANUAL_PHOTO: () => true,
  MANUAL_VIDEO: () => true,
  AWAKE_PHOTO: () => true,
  AWAKE_VIDEO: () => true,
  MOTION_PHOTO: () => true,
  MOTION_VIDEO: () => true,
  AWAKE: () => true,
  SLEEPING: (event) => event.duration > 60 * 1000
};

function isVideoEvent(eventType) {
  const videoEvents = Object.values(supportedEvents).filter((event) => {
    return event.includes("VIDEO");
  });
  return videoEvents.includes(eventType);
}

function isPhotoEvent(eventType) {
  const photoEvents = Object.values(supportedEvents).filter((event) => {
    return event.includes("PHOTO");
  });
  return photoEvents.includes(eventType);
}

function isMediaEvent(eventType) {
  return Boolean(isVideoEvent(eventType) || isPhotoEvent(eventType));
}

export {
  supportedEvents,
  eventsFilters,
  isVideoEvent,
  isPhotoEvent,
  isMediaEvent
};
